import React, { useContext, ChangeEvent } from 'react';
import { Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { TitleWrapper, TitleText } from '../../../shared/styled/TitleBar';
import { AuthenticationContext } from '../../../provider/AuthenticationProvider';
import { ROLE } from '../../../data/enums';
import apiMethods from '../../../utils/api';
import { error, success } from '../../../utils/toast';
import { VisuallyHiddenInput } from './Styled';

interface TitleProps {
    onRefreshList: Function | null;
}

const Title = ({ onRefreshList }: TitleProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const canCreate = [
        ROLE.MANAGER,
        ROLE.LOGISTIC_STAFF,
        ROLE.SALE_STAFF,
        ROLE.STORAGE_KEEPER,
        ROLE.FIRST_STORAGE_KEEPER,
        ROLE.SECOND_STORAGE_KEEPER,
        ROLE.DELIVERER,
    ].includes(role);

    const MAX_FILE_SIZE = 10 * 1024 * 1024;

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const file = files[0];

        if (file.size > MAX_FILE_SIZE) {
            error('Kích thước tệp tin không được vượt quá 10MB');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await apiMethods.post('/files/upload/', formData);
            if (response !== undefined) {
                success('THÀNH CÔNG', 'Tải tệp tin thành công');
                if (onRefreshList) {
                    onRefreshList();
                }
            } else {
                throw new Error('Tải lên tệp tin thất bại');
            }
        } catch (err: any) {
            error('Tải lên tệp tin thất bại', err);
        }
    };

    return (
        <TitleWrapper>
            <TitleText>Quản lý tệp tải lên</TitleText>
        </TitleWrapper>
    );
};

export default Title;
